import { format } from "date-fns-tz";

export const appendIfDefined = <
    T extends { append: (key: string, value: any) => void },
>(
    target: T,
    key: string,
    value: any,
) => {
    if (value !== undefined && value !== null) {
        target.append(key, value);
    }
};

// export function formatDate(
//     input: string | Date | undefined | null,
//     format: string = "DD-MM-YYYY",
// ): string {
//     if (!input) return "-";
//
//     // Normalize to string for consistent parsing
//     const isoString = typeof input === "string" ? input : input.toISOString();
//
//     // Basic ISO validation
//     if (!/^\d{4}-\d{2}-\d{2}/.test(isoString)) return "-";
//
//     const [year, month, day] = isoString.split("T")[0].split("-");
//
//     const dateObj = new Date(Date.UTC(+year, +month - 1, +day));
//     const monthShort = dateObj.toLocaleString("en-GB", {
//         month: "short",
//         timeZone: "UTC",
//     });
//
//     return format
//         .replace("DD", day)
//         .replace("MMM", monthShort)
//         .replace("MM", month)
//         .replace("YYYY", year);
// }

export function formatDate(
    input: string | Date | undefined | null,
    formatStr: string = "DD-MM-YYYY",
): string {
    if (!input) return "-";

    try {
        const date = input instanceof Date ? input : new Date(input);

        formatStr = formatStr == "DD-MM-YYYY" ? "dd-MM-yyyy" : formatStr;
        formatStr = formatStr == "DD-MMM-YYYY" ? "dd-MMM-yyyy" : formatStr;
        formatStr = formatStr == "MMM-YYYY" ? "MMM-yyyy" : formatStr;

        // Invalid date check
        if (isNaN(date.getTime())) return "-";

        // Always format in UTC (matches your original behaviour using Date.UTC)
        return format(date, formatStr, { timeZone: "UTC" });
    } catch {
        return "-";
    }
}

export * from "./normalizeArabic.ts";
export * from "./timeZoneShift.ts";
